"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Heading = _interopRequireDefault(require("../Heading"));
var _Stack = _interopRequireDefault(require("../Stack"));
var _createStyles = require("../styles/createStyles");
var _isNotNil = require("../utilities/is-not-nil");
var _BarChartColumn = _interopRequireDefault(require("./BarChartColumn"));
const useStyles = exports.useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  return {
    container: {
      overflowX: 'auto',
      marginTop: theme.busbud.spacing(3)
    }
  };
});

/**
 * **❗️ DEPRECATED**: Use the `BarChart` from pubweb instead.
 *
 * A Bar Chart component that can be used to present numerical content in an engaging way to our users.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-data-display-barchart--page)
 */
const BarChart = function BarChart(props) {
  const {
    data,
    title,
    formatter,
    noDataLabelText = 'Unknown'
  } = props;
  const {
    classes
  } = useStyles();
  if (!data.length) {
    return null;
  }
  const renderBars = () => {
    const maxValue = Math.max(...data.map(item => item.value).filter(_isNotNil.isNotNil));
    return /*#__PURE__*/_react.default.createElement(_Stack.default, {
      direction: "row",
      justifyContent: "space-between",
      className: classes.container
    }, data.map((barData, index) => {
      return /*#__PURE__*/_react.default.createElement(_BarChartColumn.default, {
        noDataLabelText: noDataLabelText,
        formatter: formatter,
        key: `${barData.label}--${index}`,
        data: barData,
        maxValue: maxValue
      });
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Heading.default, {
    size: "xxs",
    color: "text.tertiary.opaque"
  }, title), renderBars());
};
var _default = exports.default = BarChart;